var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoManagement01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Video Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 3.16,
    width: 22.01,
    height: 12.89,
    rx: 0.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.78,
    y1: 20.82,
    x2: 13.33,
    y2: 20.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.67,
    y1: 20.82,
    x2: 1.22,
    y2: 20.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.33,20.82a1.33,1.33,0,1,0-2.66,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.67,20.82a1.33,1.33,0,1,0,2.66,0"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.9 12.2 9.9 6.54 14.1 9.37 9.9 12.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoManagement01);
export default __webpack_public_path__ + "static/media/Video_Management_01.398073c15a9c88107c6ff4755c8ace76.svg";
export { ForwardRef as ReactComponent };